export const m1l4Solution = `use debug::PrintTrait;

fn main() {
    let number = 1_u8;
    number.print();
    // do not modify code on this line or above

    //TODO: Instantiate a variable to make the code compile
    let mut number = 3;
    // do not modify code on this line or below

    number = 3; // don't rename this variable
    number.print();
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
